import React from 'react'
import './main-banner.scss'
import { StaticImage } from 'gatsby-plugin-image'
import ReactPlayer from 'react-player'
import useMediaQuery from '@/utils/useMediaQuery'
import { LOCALE, LOCALE_AT } from '@/constants/activity-constants'
import { triggerTageo } from '@/utils/tagging-util'
import { siteUrl } from '@/shared/utils/siteUrl'
// OLD VIDEO https://youtu.be/kkevSIsQMrM?si=Hp2brdmX57jA8cBj
const $ROMPE = LOCALE_AT.PARAGUAY ? 'ROMPÉ' : 'ROMPE'
const $SAPOS = LOCALE_AT.COLOMBIA ? 'SAPOS' : '"CHISMOSOS"'
const VIDEO =
  {
    'es-CL': 'https://www.youtube.com/watch?v=1kuFj-UDUbo',
  }[LOCALE] || 'https://youtu.be/qbTuIh-JI6Q'
const onClickPreviewHandler = async () => {
  const location = window.location
  triggerTageo('7A', {
    label: 'play',
    location: location.host + location.pathname + '#inicio',
  })
  let interaval = setInterval(() => {
    const tag = document.querySelector(
      "script[src='https://www.youtube.com/iframe_api']"
    )
    if (!tag) return
    const parent = tag.parentElement
    tag.remove()
    tag.type = 'text/javascript'
    parent.appendChild(tag)
    clearInterval(interaval)
  }, 10)
}

const bannerImage = isMobile => {
  if (!isMobile) {
    return (
      <StaticImage
        src="../../../assets/images/banner-loving-desktop.png"
        alt="loving-banner"
        className="f-banner-loving-image"
        placeholder="blurred"
        height={403}
      />
    )
  } else {
    return (
      <StaticImage
        src="../../../assets/images/banner-loving-mobile.png"
        alt="loving-banner"
        className="f-banner-loving-image"
        placeholder="blurred"
        height={400}
      />
    )
  }
}
const MainBanner = ({ id }) => {
  const isMobile = useMediaQuery(440)

  return (
    <>
      <section className="f-banner-loving">
        <div className="wrapper">
          <div className="f-banner-loving-text">
            <h1>YO ESTOY DEL LADO DEL LOVING Y NO NECESITO TU APROBACIÓN</h1>
          </div>
          {bannerImage(isMobile)}
        </div>
      </section>
      <section id={id} className="f-loving-video">
        <ReactPlayer
          url={VIDEO}
          light={true}
          className={'f-loving-video-player '}
          controls={true}
          onClickPreview={onClickPreviewHandler}
          volume={0.9}
          playing={true}
        />
        <div className="f-loving-video-stadistics">
          <p className="big">
            EL <b>84%</b>
          </p>
          <div className="info-data">
            <p>
              de los casos de bullying <b>terminan</b> cuando otros intervienen*{' '}
              <br />
              <br />
              <span>
                *OCDE
                <small>
                  (Organización para la cooperación y el desarrollo económico)
                </small>
              </span>
            </p>
          </div>
          <div className="break">
            <span className="bigger">{$ROMPE}</span>
            <span className="mid"> EL SILENCIO</span>
          </div>
          <p className="quote">
            HABLAR NO ES DE {$SAPOS}, <br />
            ES DE VALIENTES
          </p>
        </div>
      </section>
    </>
  )
}

export default MainBanner
